module.exports = __webpack_public_path__ + "img/舞夏.31158f78.svg";